const RatingStar = () => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9526 4.19848L10.7652 3.62683L7.01828 3.56919L5.77891 0H5.17364L3.9679 3.54517L0.187346 3.62683L0 4.19848L2.99754 6.44664L1.90709 10.0639L2.39227 10.4193L5.45706 8.25765L8.56029 10.4193L9.04547 10.0639L7.9406 6.48507L10.9526 4.19848Z" fill="#FFAA00"/>
    </svg>
  );
};

export default RatingStar;
